import { render, staticRenderFns } from "./NewtonThirdLawViz.vue?vue&type=template&id=322f02f6&scoped=true"
import script from "./NewtonThirdLawViz.vue?vue&type=script&lang=js"
export * from "./NewtonThirdLawViz.vue?vue&type=script&lang=js"
import style0 from "./NewtonThirdLawViz.vue?vue&type=style&index=0&id=322f02f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322f02f6",
  null
  
)

export default component.exports